// Create a custom button by extending the Video.js Button component
// === Example Custom Button ===
import videojs from 'video.js';
const Button = videojs.getComponent('Button');

function createCustomButton(className, label, onClick) {
  const CustomBtn = videojs.extend(Button, {
    constructor: function (player, options) {
      Button.call(this, player, options);
      this.addClass(className);
      this.controlText(label);
      this.onClickHandler = options.onClickHandler; // store handler
    },
    handleClick: function () {
      if (typeof this.onClickHandler === 'function') {
        this.onClickHandler(this.player()); // pass the player instance
      }
    }
  });

  return CustomBtn;
}

// Helper to register and add buttons
export function addCustomButtons(player, newSeriesSlug, handlers = {}) {
  // Create Hello Button
  const rewindButton = createCustomButton('rewind-button', 'Rewind', handlers.onRewindClick);

  // Create Download Button
  const forwardButton = createCustomButton('forward-button', 'Forward', handlers.onForwardClick);
  const playlistButton = createCustomButton(
    'playlist-button',
    'Playlist',
    handlers.onPlaylistClick
  );
  const nextButton = createCustomButton('next-button', 'Next', handlers.onNextClick);

  // Register components
  videojs.registerComponent('customRewindButton', rewindButton);
  videojs.registerComponent('customForwardButton', forwardButton);
  newSeriesSlug && videojs.registerComponent('customPlaylistButton', playlistButton);
  newSeriesSlug && videojs.registerComponent('customNextButton', nextButton);

  // Add them to the control bar
  const controlBar = player.getChild('controlBar');
  controlBar.addChild('customRewindButton', { onClickHandler: handlers.onRewindClick }, 1);
  controlBar.addChild('customForwardButton', { onClickHandler: handlers.onForwardClick }, 2);
  newSeriesSlug &&
    controlBar.addChild('customNextButton', { onClickHandler: handlers.onNextClick }, 3);
  newSeriesSlug &&
    controlBar.addChild('customPlaylistButton', { onClickHandler: handlers.onPlaylistClick }, 12);
}

// ==== Adds Keyboard support and youtube like experience ====
export function addVideoJsHotkeys(player) {
  if (!player) return;

  const handleKeyDown = (e) => {
    switch (e.key) {
      case 'ArrowLeft': {
        const newTime = Math.max(0, player.currentTime() - 5);
        player.currentTime(newTime);
        break;
      }
      case 'ArrowRight': {
        const newTime = Math.min(player.duration(), player.currentTime() + 5);
        player.currentTime(newTime);
        break;
      }
      case 'ArrowUp': {
        e.preventDefault(); // stop page scrolling
        const newVolume = Math.min(1, player.volume() + 0.1);
        player.volume(newVolume);
        break;
      }
      case 'ArrowDown': {
        e.preventDefault();
        const newVolume = Math.max(0, player.volume() - 0.1);
        player.volume(newVolume);
        break;
      }
      // case ' ': {
      //   // space bar
      //   e.preventDefault();
      //   if (player.paused()) {
      //     player.play();
      //   } else {
      //     player.pause();
      //   }
      //   break;
      // }
      default:
        break;
    }
  };

  // make sure player element can capture key events
  const playerEl = player.el();
  playerEl.setAttribute('tabindex', '0');
  playerEl.addEventListener('keydown', handleKeyDown);

  // return cleanup function (optional)
  return () => {
    playerEl.removeEventListener('keydown', handleKeyDown);
  };
}
